module.exports = __webpack_public_path__ + "media/images/logos/app-logo-white-6fef6f2ebf6b7663ed0714f1e01ccc2e.png";